import { createContext } from 'react';

import { Customer, TMSCustomer } from 'types/Load';

export type LoadBuildingGuardrailCustomer = {
  id?: number;
  externalTMSID?: string;
  name?: string;
  isTest?: boolean;
};

export type GuardedLoadSubmitOptions = {
  acknowledgeProdTMSOverride?: boolean;
};

export type LoadBuildingGuardrailContextValue = {
  requestSubmit: (
    customer:
      Customer | TMSCustomer | LoadBuildingGuardrailCustomer | undefined,
    submit: (opts: GuardedLoadSubmitOptions) => Promise<void>
  ) => Promise<void>;
  showBanner: boolean;
  isTestingEnvironment: boolean;
  tmsName?: string;
};

export const LoadBuildingGuardrailContext =
  createContext<LoadBuildingGuardrailContextValue | null>(null);

/** Used when the form renders outside LoadBuildingGuardrailProvider (e.g. load edit view). */
export const noopLoadBuildingGuardrail: LoadBuildingGuardrailContextValue = {
  requestSubmit: async (_customer, submit) => submit({}),
  showBanner: false,
  isTestingEnvironment: false,
};
